import { IRootState } from '../../../../store'
import { IMedicalConsultState } from '../store/medicalConsult.types'

export const getMedicalConsultSelector = (state: IRootState): IMedicalConsultState => state.medicalConsult
